import { Box, Typography } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';
import { useTranslation } from 'react-i18next';

const NoRowsOverlay = () => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                gap: 1,
                color: 'text.secondary',
                backgroundColor: (theme) => theme.palette.background.paper,
            }}
        >
            <InboxIcon sx={{ fontSize: 48, opacity: 0.4 }} />
            <Typography variant="body2">
                {t('general.table.noRows', 'No hay datos para mostrar')}
            </Typography>
        </Box>
    );
};

export { NoRowsOverlay };
